// IMPORTANT: Replace with your own domain address - it's used for SEO in meta tags and schema
const baseURL = 'https://imanolortega.dev';

const routes = {
  '/': true,
  '/about': true,
  '/work': true,
  '/blog': false,
  '/gallery': false,
};

// Enable password protection on selected routes
// Set password in the .env file, refer to .env.example
const protectedRoutes = {
  '/work/automate-design-handovers-with-a-figma-to-code-pipeline': true,
};

import { Geist } from 'next/font/google';
import { Geist_Mono } from 'next/font/google';

const primaryFont = Geist({
  variable: '--font-primary',
  subsets: ['latin'],
  display: 'swap',
});

const monoFont = Geist_Mono({
  variable: '--font-code',
  subsets: ['latin'],
  display: 'swap',
});

const font = {
  primary: primaryFont,
  secondary: primaryFont,
  tertiary: primaryFont,
  code: monoFont,
};

const style = {
  theme: 'dark', // theme is not necessary when using ThemeProvider (default)
  neutral: 'gray', // sand | gray | slate
  brand: 'cyan', // blue | indigo | violet | magenta | pink | red | orange | yellow | moss | green | emerald | aqua | cyan
  accent: 'red', // blue | indigo | violet | magenta | pink | red | orange | yellow | moss | green | emerald | aqua | cyan
  solid: 'contrast', // color | contrast
  solidStyle: 'flat', // flat | plastic
  border: 'playful', // rounded | playful | conservative
  surface: 'translucent', // filled | translucent
  transition: 'all', // all | micro | macro
  scaling: '100', // 90 | 95 | 100 | 105 | 110
};

const effects = {
  mask: {
    cursor: false,
    x: 50,
    y: 0,
    radius: 100,
  },
  gradient: {
    display: false,
    opacity: 100,
    x: 50,
    y: 60,
    width: 100,
    height: 50,
    tilt: 0,
    colorStart: 'accent-background-strong',
    colorEnd: 'page-background',
  },
  dots: {
    display: true,
    opacity: 40,
    size: '2',
    color: 'brand-background-strong',
  },
  grid: {
    display: false,
    opacity: 100,
    color: 'neutral-alpha-medium',
    width: '0.25rem',
    height: '0.25rem',
  },
  lines: {
    display: false,
    opacity: 100,
    color: 'neutral-alpha-weak',
    size: '16',
    thickness: 1,
    angle: 45,
  },
};

const display = {
  location: true,
  time: true,
  themeSwitcher: true,
};

const mailchimp = {
  action: 'https://url/subscribe/post?parameters',
  effects: {
    mask: {
      cursor: true,
      x: 50,
      y: 0,
      radius: 100,
    },
    gradient: {
      display: true,
      opacity: 90,
      x: 50,
      y: 0,
      width: 50,
      height: 50,
      tilt: 0,
      colorStart: 'accent-background-strong',
      colorEnd: 'static-transparent',
    },
    dots: {
      display: true,
      opacity: 20,
      size: '2',
      color: 'brand-on-background-weak',
    },
    grid: {
      display: false,
      opacity: 100,
      color: 'neutral-alpha-medium',
      width: '0.25rem',
      height: '0.25rem',
    },
    lines: {
      display: false,
      opacity: 100,
      color: 'neutral-alpha-medium',
      size: '16',
      thickness: 1,
      angle: 90,
    },
  },
};

export {
  routes,
  protectedRoutes,
  effects,
  style,
  display,
  mailchimp,
  baseURL,
  font,
};
